import ImportantInfoModal from "./ImportantInfoModal";

export default ImportantInfoModal;
